// This file is duplicated in the support-conversations package. The two copies should be kept in sync.

export enum Visibility {
  Open = 'open',
  Minimized = 'minimized',
  Closed = 'closed',
}
